import { render, staticRenderFns } from "./RejectAmountRecieved.vue?vue&type=template&id=59a608cd&scoped=true&"
import script from "./RejectAmountRecieved.vue?vue&type=script&lang=js&"
export * from "./RejectAmountRecieved.vue?vue&type=script&lang=js&"
import style0 from "./RejectAmountRecieved.vue?vue&type=style&index=0&id=59a608cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a608cd",
  null
  
)

export default component.exports